<template>
  <div class="change-indicator" />
</template>

<script setup>
</script>

<style scoped lang="scss" type="text/scss">

.change-indicator {
  background: map_get($colors, 'yellow', 'base');
  border: 1px solid white;
  width: 9px;
  height: 9px;
  border-radius: 9px;
}
</style>
